// System Logs Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get logs list from backend then update logsList in vuex store ***** //
export const updateLogsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('log_info_index', { params: params })
    commit('updateLogsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch log info ***** //
export const fetchLogInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`log_info_show/${payload}`)
    commit('setLogInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}
